var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trialStatus)?_c('app-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"icon",attrs:{"data-e2e-id":_vm.kebab(_vm.trialStatus.text) + '-icon'}},on),[_c(_vm.trialStatus.icon,{tag:"component"})],1)]}}],null,false,1203441143)},[_vm._v(" "+_vm._s(_vm.trialStatus.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }